// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14 10V12C14 13.1 13.1 14 12 14H4C2.9 14 2 13.1 2 12V10M8 10.25L8 2M10.96 7.29L8 10.25L5.04 7.29',
];
